import type { ExActAndConfigCouponInfo } from '@/types/coupon';
import { useCouponStore } from '@/store/coupon';
import { storeToRefs } from 'pinia';
import { computed, type ComputedRef } from '@vue/composition-api';

export function useCouponInfo(couponId): ComputedRef<ExActAndConfigCouponInfo | void> {
  const couponStore = useCouponStore();
  const { formattedCouponList } = storeToRefs(couponStore);
  const couponInfo = computed(() => formattedCouponList.value.find(item => item.couponId === couponId));
  return couponInfo;
}
